<template>
  <div class="sales-distribution-ranking">
    <div class="line-chart">

    </div>
  </div>

</template>

<script>
import echarts from 'echarts'

export default {

  data() {
    return {
      myChart: null,
      data: [],
      cities: []
    }
  },
  props: ['sales_data'],

  created() {
    var sortedData = this.sales_data.sort(
      function(obj1, obj2) {
        return obj2['value'] - obj1['value']
      }
    )

    for (var i = 0; i < 10; i++) {
      this.cities.push(sortedData[i]['name'])
      this.data.push(sortedData[i]['value'])
    }

    this.cities.reverse()
    this.data.reverse()

    this.$nextTick(() => {
      let option = {
    title: {
        text: '区域销量排名',
        left: 'center',
        top: 15
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
    },
    yAxis: {
        type: 'category',
        data: this.cities
    },
    series: [
        {
            name: '销量',
            type: 'bar',
            data: this.data,
            barWidth: 30,
        }
    ]
};
    this.myChart = echarts.init(document.querySelector('.sales-distribution-ranking .line-chart'))
    this.myChart.setOption(option, true)
    // this.legendArr = options.series
    // this.legendArr.forEach((data) => {
    //   data.selected = true;
    // })
    window.addEventListener('resize', function() {
      this.myChart.resize()
    }.bind(this))
    })
  },

  methods: {
    initialize(options) {

      // console.log(this.myChart);
    }
  }
}
</script>

<style scoped lang="scss">
.sales-distribution-ranking {
  width: 500px;
  height: 600px;

  .line-chart {
    width: 500px;
    height: 600px;
  }
}


</style>



// WEBPACK FOOTER //
// src/views/index/data-analysis/sales/sales-distribution-ranking.vue